import React, { useEffect, useRef, useState } from "react";

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import Button from "../../../components/button";
import { ROUTES } from "../../../routes";
import { useNavigate, useParams } from "react-router";

import API from "../../../api";

import { uniqueId } from "lodash";
import clsx from "clsx";

import "./styles.css";
import ImageCropper from "../cropper";
import ImageOrderUpdate from "../order/images";
import Slider, { makeSettings } from "../../../components/slider";
import { useLanguage } from '@languages/index';

const SNSShow = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  const params = useParams();
  const postingId = useRef(props.modalMode ? props.postingId : params.postingId);

  const navigate = useNavigate();
  const [posting, setPosting] = useState<any>();
  const [isFetching, setIsFetching] = useState(false);

  const currentSlidePage = useRef<number>(0);

  const fetchPosting = (postingId: any) => {
    setIsFetching(true);
    API.Post.show({
      brandToken: props.auth.token,
      postingId: postingId,
    })
      .then((response: any) => {
        
        // Model 자체에서 products 순서를 뒤집어놨는데 이유를 알 수 없음.
        // 엮인 곳이 많다보니 사이드이펙트가 우려되서 클라이언트단에서 해결
        if (response?.data?.posting?.products != null) {
          response.data.posting.products = response.data.posting.products.reverse();
        }
        setPosting(response.data.posting);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const renderLoadingIndicator = () => {
    return isFetching ? (
      <div className="flex flex-row mx-10 my-10 justify-center items-center">
        <div className="flex flex-row justify-center text-center my-5">
          <span className="prose prose-xl text-slate-400">
            {languageTexts.loading_1}
          </span>
        </div>
      </div>
    ) : null;
  };

  useEffect(() => {
    fetchPosting(postingId.current);
  }, []);

  useEffect(() => {
    if (
      props.brand?.hasExperiencedSnsInstall &&
      !props.brand?.snsPassInstalledAt
    ) {
      navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
    }
  }, []);

  const toggleProvide = (id: number, value: boolean) => {
    API.SnsPosting.toggle({
      brandToken: props.auth.token,
      id: id,
      value: value ? "true" : "false",
    })
      .then((response) => {
        props.showModal({ text: response.message });
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      })
      .finally(() => {
        fetchPosting(id);
      });
  };

  const getSizeText = () => {
    let textArr = [];

    if (posting.age) {
      textArr.push(languageTexts._age(posting.age));
    }
    if (posting.height) {
      textArr.push(languageTexts._height(posting.height));
    }
    if (posting.topSize) {
      textArr.push(languageTexts._top_size(posting.topSize));
    }
    if (posting.bottomSize) {
      textArr.push(languageTexts._bottom_size(posting.bottomSize));
    }

    return textArr.join(" / ");
  };

  const getEtcSizeText = () => {
    let textArr = [];

    if (posting.isUnderwearIncluded && posting.braSize) {
      textArr.push(languageTexts._bra_size(posting.braSize));
    }
    if (posting.isUnderwearIncluded && posting.pantieSize) {
      textArr.push(languageTexts._pantie_size(posting.pantieSize));
    }
    if (posting.isShoesIncluded && posting.shoesSize) {
      textArr.push(languageTexts._shoes_size(posting.shoesSize));
    }

    return textArr.join(" / ");
  };

  const getUrlText = (url: string) => {
    if (!url) return "";

    if (url.startsWith("http")) {
      return url;
    } else {
      return `https://${url}`;
    }
  };

  const showProductUrlEditModal = (postingProduct) => {
    console.log("postingProduct", postingProduct);

    props.showModal({
      title: languageTexts.right_side_text_1,
      text: languageTexts.right_side_text_2,
      input: {
        type: "text",
        placeholder: "https://",
      },
      cancel: () => {},
      confirm: (value) => {
        API.SnsProduct.update({
          brandToken: props.auth.token,
          postingId: posting.id,
          postingProductId: postingProduct.id,
          url: value,
        })
          .then((response) => {
            setTimeout(() => {
              props.showModal({ text: response.message });
              setPosting(response.data.posting);
            }, 400);
          })
          .catch((error) => {
            setTimeout(() => {
              props.showModal({ text: error.message });
            }, 400);
          });
      },
    });
  };

  const onLinkClick = (url: string) => {
    const targetLink = url.startsWith("http") ? url : `http://${url}`;
    window.open(targetLink, "_blank");
  };

  const renderProducts = (products: any) => {
    return products.map((product) => {
      return (
        <div key={product.id} className="flex flex-row border border-gray-200 p-[0.875rem] items-center cursor-pointer">
          <div className="flex w-16 h-16 aspect-square">
            <img
              className="w-full h-full object-cover"
              src={product.thumbSmUrl}
              alt={product.name}
            />
          </div>

          <div className="flex flex-col gap-1 w-full overflow-hidden px-5">
            <span className="font-medium text-[15px] whitespace-nowrap overflow-hidden overflow-ellipsis">
              {product.name}
            </span>

            <span
              className="text-black text-[15px] font-normal"
              style={{ wordBreak: "keep-all" }}
            >
              {languageTexts._wear(product.sizeName)}
            </span>

            <div className="flex flex-row gap-5 justify-between">
              <a
                className="text-[15px] text-[#0066FF] underline whitespace-nowrap truncate text-ellipsis overflow-hidden max-w-[350px]"
                onClick={() => {
                  onLinkClick(product.url);
                }}
              >
                {`${getUrlText(product.url)}`}
              </a>

              <span
                className="underline text-[15px] text-[#999999] cursor-pointer hover:text-black"
                onClick={() => {
                  showProductUrlEditModal(product);
                }}
              >
                {languageTexts.change2}
              </span>
            </div>
          </div>
        </div>
      );

      return (
        <div className="flex flex-row gap-[13px]">
          <div className="w-[4rem] h-[4rem]">
            <img
              className="w-full h-full overflow-hidden object-contain"
              src={product.thumbSmUrl}
            />
          </div>

          <div className="flex flex-col gap-[6px] w-full justify-center md:max-w-[85%] px-3">
            <span
              className="font-medium text-[15px] max-w-[480px]"
              style={{ wordBreak: "keep-all" }}
            >
              {product.name}
            </span>

            <span
              className="text-black text-[15px] font-normal"
              style={{ wordBreak: "keep-all" }}
            >
              {languageTexts._wear(product.sizeName)}
            </span>

            <div className="flex flex-row gap-5">
              <a
                className="text-[15px] text-[#0066FF] underline whitespace-nowrap truncate text-ellipsis overflow-hidden max-w-[480px]"
                onClick={() => {
                  onLinkClick(product.url);
                }}
              >
                {`${getUrlText(product.url)}`}
              </a>

              <span
                className="underline text-[15px] text-[#999999] cursor-pointer hover:text-black"
                onClick={() => {
                  showProductUrlEditModal(product);
                }}
              >
                {languageTexts.change2}
              </span>
            </div>
          </div>
        </div>
      );
    });
  };

  const showCropModal = (image, imageIndex) => {
    let imageUrl = image.thumbSmUrl.replace("/thumb-sm/", "/thumb/");
    if (image.imgUrlCropped) imageUrl = imageUrl.replace("/thumb", "");

    props.showModal({
      content: () => (
        <ImageCropper
          {...props}
          image={image}
          index={imageIndex}
          url={imageUrl}
          onUpdate={(img, updatedIndex, response) => {
            const images = [
              ...posting.images.map((image) => {
                return image.thumbSmUrl == img.thumbSmUrl
                  ? {
                      ...image,
                      thumbSmUrl: `${
                        response.data.url
                      }?timestamp=${Date.now().toString()}`,
                    }
                  : image;
              }),
            ];
            setPosting({ ...posting, ...{ images: images } });
          }}
        />
      ),
    });
  };

  const showUndoCropModal = (image) => {
    props.showModal({
      title: languageTexts.show_index_text_1,
      text: languageTexts.show_index_text_2,
      confirm: () => {
        API.Post.undoCrop({
          brandToken: props.auth.token,
          imageId: image.id,
        })
          .then((response) => {
            const images = [
              ...posting.images.map((image) => {
                return image.id == response.data.image.id
                  ? {
                      ...image,
                      thumbSmUrl: `${
                        response.data.image.thumbSmUrl
                      }?timestamp=${Date.now().toString()}`,
                    }
                  : image;
              }),
            ];
            setPosting({ ...posting, ...{ images: images } });
            setTimeout(() => {
              props.showModal({ text: response.message });
            }, 400);
          })
          .catch((error) => {
            setTimeout(() => {
              props.showModal({ text: error.message });
            }, 400);
          });
      },
      cancel: () => {},
    });
  };

  const showUpdateOrderModal = (posting, images) => {
    props.showModal({
      content: () => {
        return (
          <ImageOrderUpdate
            posting={posting}
            images={images}
            onUpdate={(posting) => {
              setPosting(posting);
            }}
          />
        );
      },
    });
  };

  const render = () => {
    if (!props.brand?.hasExperiencedSnsInstall) {
      return null;
    }

    if (!props.brand?.snsPassInstalledAt) {
      return null;
    }

    if (!posting) {
      return null;
    }

    return (
      <div className="flex flex-col justify-center">
        <div className={clsx({
          "flex flex-col w-full max-w-[1025px] mx-auto gap-[3.75rem]": true,
          "my-[4.25rem]": !props.modalMode,
          "my-[2.5rem]": props.modalMode,
        })}>
          <div className="flex flex-row">
            <div
              className="flex flex-row gap-[0.625rem] cursor-pointer"
              onClick={() => {
                if (props.modalMode === true && props.letClose != null) {
                  props.letClose();
                  return;
                }
                history.back();
              }}
            >
              <img src={"/assets/icons/ic-chevron-left-black.svg"} />
              <span className="font-bold text-[1.375rem]">{props.modalMode === true ? languageTexts.close2 : languageTexts.button_prev_3}</span>
            </div>
          </div>

          <div className="flex flex-row gap-[3.125rem]">
            <div className="flex flex-col gap-[1.5rem]">
              <div className="aspect-[0.7825] max-w-[25rem] overflow-hidden">
                <Slider
                  {...makeSettings({})}
                  afterChange={(index) => {
                    currentSlidePage.current = index;
                  }}
                >
                  {posting.images.map((image) => {
                    return (
                      <img
                        onClick={() => {}}
                        key={`postingCardImage${uniqueId()}`}
                        className="object-cover"
                        src={image.thumbSmUrl}
                      />
                    );
                  })}
                </Slider>
              </div>

              <div className="flex flex-row justify-around">
                <span
                  className="underline text-[15px] hover:font-bold cursor-pointer"
                  onClick={() => {
                    showCropModal(
                      posting.images[currentSlidePage.current],
                      currentSlidePage.current
                    );
                  }}
                >
                  {languageTexts.show_index_text_3}
                </span>
                <span
                  className="underline text-[15px] hover:font-bold cursor-pointer"
                  onClick={() => {
                    showUndoCropModal(posting.images[currentSlidePage.current]);
                  }}
                >
                  {languageTexts.show_index_text_1}
                </span>
                {posting.images.length > 1 ? (
                  <span
                    className="underline text-[15px] hover:font-bold cursor-pointer"
                    onClick={() => {
                      showUpdateOrderModal(posting, posting.images);
                    }}
                  >
                    {languageTexts.show_index_text_4}
                  </span>
                ) : null}
              </div>
            </div>

            <div className="flex flex-col min-w-[572px] gap-[2.5rem]">
              <div className="flex flex-row justify-between">
                {props.modalMode
                  ? (
                    <div className="flex flex-row w-full max-w-[12rem]"></div>
                  )
                  : (
                    <div className="flex flex-row w-full max-w-[12rem]">
                      <Button
                        borderColor={posting.publishedAt ? "#000000" : "#E8E8E8"}
                        buttonColor={posting.publishedAt ? "#000000" : "WHITE"}
                        textColor={posting.publishedAt ? "WHITE" : "BLACK"}
                        text={languageTexts.public}
                        textClassName={"text-sm"}
                        onClick={() => toggleProvide(posting.id, true)}
                      />
                      <Button
                        buttonColor={posting.publishedAt ? "WHITE" : "#E8E8E8"}
                        borderColor={posting.publishedAt ? "#E8E8E8" : "#E8E8E8"}
                        text={languageTexts.private}
                        textClassName={"text-sm"}
                        onClick={() => toggleProvide(posting.id, false)}
                      />
                    </div>
                  )
                }

                <div
                  onClick={() => {
                    navigate(ROUTES.SNS_UPDATE.UPDATE(posting.id));
                  }}
                >
                  <span className="underline text-md hover:font-bold cursor-pointer">
                    {languageTexts.celeb_detail_text_7}
                  </span>
                </div>
              </div>

              <div className="flex flex-row">
                <div className="flex flex-col gap-[15px] w-full">
                  <div className="flex flex-row">
                    <span className="font-medium text-[22px]">{languageTexts.create_text_12}</span>
                  </div>

                  <div className="flex flex-row">
                    <div className="mr-[13px]">
                      <img
                        className="w-[4rem] h-[4rem] rounded-full overflow-hidden"
                        src={posting.profileThumbUrl}
                      />
                    </div>

                    <div className="flex flex-col gap-[6px] justify-center flex-1">
                      <span className="font-medium text-[15px]">
                        {posting.username}
                      </span>

                      <div className="flex flex-col">
                        <span className="text-[15px]">{getSizeText()}</span>
                        <span className="text-[15px]">{getEtcSizeText()}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-row">
                <div className="flex flex-col gap-[15px] w-full">
                  <div className="flex flex-row">
                    <span className="font-medium text-[22px]">{languageTexts.celeb_detail_text_8}</span>
                  </div>

                  {renderProducts(posting.products)}
                </div>
              </div>
            </div>
          </div>

          {renderLoadingIndicator()}
        </div>
      </div>
    );
  };

  return <>{render()}</>;
};

export default connect(mapStateToProps, mapDispatchProps)(SNSShow);
